import React, { useState, useEffect } from 'react';
import { Container, Link } from '@mui/material';

import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PageHeader from 'components/global/PageHeader';
import ProgressIndicator from 'components/global/ProgressIndicator';

const PermissionDeniedSplash = () => {
  const [loading, setLoading] = useState(false);
  
  // Use useEffect to trigger redirect after 15 seconds
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Redirect to /programs after 30 seconds
      setLoading(true);
      window.location.href = '/';
    }, 9000); // 9 seconds in milliseconds

    // Clear the timeout on component unmount
    return () => clearTimeout(timeoutId);
  }, []); // Empty dependency array ensures the effect runs only once on component mount


  return (
    <>
      <ProgressIndicator isOpen={loading} title="Loading..." />
      <Container maxWidth="xl" sx={{ p: 14, mb: 2 }}>
        <PageHeader title="This page isn't available to you" />

        <Grid container sx={{mt: 5}}>
          <Grid item xs={2}></Grid>
          <Grid item xs={8}>
              <Stack spacing={5}>
                  <Alert severity="info">You are being redirected back to Home</Alert>
              </Stack>
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PermissionDeniedSplash;